module.exports = __webpack_public_path__ + "img/avatar.46a14bc9.png";